import RequestSampleForm from "./RequestSampleForm"
import { useLayoutEffect } from "react"
import { Redirect, useLocation } from "react-router-dom"
/**
 *
 * @param {*} param0
 */
const RequestSampleApp = ({ headerTitle }) => {
  const { state } = useLocation()
  useLayoutEffect(() => {
    if (document && headerTitle) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
      document.getElementById("pageTitle").innerText = headerTitle
    }
  }, [])

  if (typeof state === "undefined" || (state && state.preview === null)) {
    return <Redirect to="/togo/customization" />
  } else {
    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-3">
            <div className="goBagRequestSample__result">
              <img src={state.preview} alt="preview" />
              <hr />
              <img src={state.bagPreview.thumb} alt="bag preview" />
            </div>
          </div>
          <div className="col-xs-12 col-md-9">
            <RequestSampleForm
              preview={state.preview}
              originalSource={state.bagPreview.original}
              model={state.model}
            />
          </div>
        </div>
      </div>
    )
  }
}

RequestSampleApp.defaultProps = {
  headerTitle: "Request a Quote",
}

export default RequestSampleApp
